var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useContext, useEffect, useState } from 'react';
import rollbar from 'shared-assets/src/errors/errors';
import { Button, DownCaretIcon, List, ListItem, ListItemText, Typography, Popover, } from '@kareo/design-system';
import styled from 'styled-components';
import { getPatientPortalInfo } from 'shared-assets/facesheet-ui/service/facesheet/service';
import { MoreMenuTitles, PATIENT_EDUCATION_URL, PORTAL_INACTIVE_ERROR, } from 'shared-assets/facesheet-ui/service/legacy/types';
import { getExportUrl } from 'shared-assets/facesheet-ui/utils/patientHelper';
import ImportSummaryOfCare from 'shared-assets/facesheet-ui/components/Facesheet/Header/ImportSummaryOfCare';
import { useSnackbar } from 'notistack';
import { PracticePermissionsContext, UserPermissionsContext, } from 'shared-assets/facesheet-ui/components/Facesheet/Container/ChartPermissionsCheck';
import { GENERAL_ERROR } from 'shared-assets/facesheet-ui/service/patient/types';
import AlertButton from 'shared-assets/facesheet-ui/components/Facesheet/Error/AlertButton';
import PatientEducationModal from './PatientEducationModal';
import ExportModalCard from './ExportModalCard';
var StyledList = styled(List)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    padding: 0;\n    margin: 0;\n  }\n"], ["\n  &&& {\n    padding: 0;\n    margin: 0;\n  }\n"])));
var MoreMenu = function (_a) {
    var patientId = _a.patientId;
    var practicePermissions = useContext(PracticePermissionsContext);
    var userPermissionsContext = useContext(UserPermissionsContext);
    var _b = useState(false), inError = _b[0], setInError = _b[1];
    var _c = useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var open = Boolean(anchorEl);
    var _d = useState(''), patientPortalUrl = _d[0], setPatientPortalUrl = _d[1];
    var _e = useState(false), hasActivePatientPortalAccount = _e[0], setHasActivePatientPortalAccount = _e[1];
    var _f = useState(false), isPatientEducationOpen = _f[0], setIsPatientEducationOpen = _f[1];
    var _g = useState(false), isExportOpen = _g[0], setIsExportOpen = _g[1];
    var _h = useState(''), exportHeaderTitle = _h[0], setExportHeaderTitle = _h[1];
    var _j = useState(false), isSOCModalOpen = _j[0], setIsSOCModalOpen = _j[1];
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var handleMenuClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
    };
    var handleSecureMessageClick = function () {
        if (inError) {
            enqueueSnackbar(GENERAL_ERROR, {
                variant: 'error',
                action: action,
            });
        }
        else if (!hasActivePatientPortalAccount) {
            enqueueSnackbar(PORTAL_INACTIVE_ERROR, {
                variant: 'error',
            });
        }
        else {
            window.open(patientPortalUrl, '_blank');
        }
        handleMenuClose();
    };
    var handlePatientEducationClick = function () {
        handleMenuClose();
        if (inError) {
            enqueueSnackbar(GENERAL_ERROR, {
                variant: 'error',
                action: action,
            });
        }
        else {
            setIsPatientEducationOpen(true);
        }
    };
    var handlePatientEducationClose = function () {
        setIsPatientEducationOpen(false);
    };
    var handleExportClose = function () {
        setIsExportOpen(false);
    };
    var setExportModalCard = function (event) {
        var input = event.target;
        setIsExportOpen(true);
        handleMenuClose();
        setExportHeaderTitle(input.innerText);
    };
    var exportData = function () {
        window.location.href = getExportUrl(exportHeaderTitle) + "patientId=" + patientId;
        setIsExportOpen(false);
    };
    var handleSummaryOfCareClick = function () {
        handleMenuClose();
        setIsSOCModalOpen(true);
    };
    var closeSOCModal = function () {
        setIsSOCModalOpen(false);
    };
    var action = function () {
        return React.createElement(AlertButton, null);
    };
    useEffect(function () {
        if (patientId && patientId != 0) {
            getPatientPortalInfo(patientId)
                .then(function (patientPortalInfoResponse) {
                if (patientPortalInfoResponse.hasActivePatientPortalAccount != null) {
                    setHasActivePatientPortalAccount(patientPortalInfoResponse.hasActivePatientPortalAccount);
                }
                if (patientPortalInfoResponse.sendPatientPortalMessageUrl != null) {
                    setPatientPortalUrl(patientPortalInfoResponse.sendPatientPortalMessageUrl);
                }
            })
                .catch(function (error) {
                rollbar.error(error);
                setInError(true);
            });
        }
    }, [patientId]);
    var clinicalListItems = [
        React.createElement(ListItem, { onClick: handlePatientEducationClick, key: MoreMenuTitles.Education },
            React.createElement(ListItemText, { primary: MoreMenuTitles.Education })),
        React.createElement(ListItem, { onClick: setExportModalCard, key: MoreMenuTitles.Immunization },
            React.createElement(ListItemText, { primary: MoreMenuTitles.Immunization })),
        React.createElement(ListItem, { onClick: setExportModalCard, key: MoreMenuTitles.Surveillance },
            React.createElement(ListItemText, { primary: MoreMenuTitles.Surveillance })),
        React.createElement(ListItem, { onClick: handleSummaryOfCareClick, key: MoreMenuTitles.Summary },
            React.createElement(ListItemText, { primary: MoreMenuTitles.Summary })),
        React.createElement(ListItem, { onClick: setExportModalCard, key: MoreMenuTitles.Referral },
            React.createElement(ListItemText, { primary: MoreMenuTitles.Referral })),
        React.createElement(ListItem, { onClick: setExportModalCard, key: MoreMenuTitles.Continuity },
            React.createElement(ListItemText, { primary: MoreMenuTitles.Continuity })),
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "text", endIcon: React.createElement(DownCaretIcon, { fontSize: "small" }), onClick: function (e) {
                e.preventDefault();
                handleMenuClick(e);
            }, color: "vitality" },
            React.createElement(Typography, { component: "div" }, "More")),
        React.createElement(Popover, { id: "more_menu_id", open: open, anchorEl: anchorEl, onClose: handleMenuClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, disableScrollLock: true },
            React.createElement(StyledList, { "aria-label": "more_menu_list" },
                React.createElement(ListItem, { key: MoreMenuTitles.Secure, onClick: handleSecureMessageClick },
                    React.createElement(ListItemText, { primary: MoreMenuTitles.Secure })),
                (practicePermissions === null || practicePermissions === void 0 ? void 0 : practicePermissions.clinicalProductEnabled) && (userPermissionsContext === null || userPermissionsContext === void 0 ? void 0 : userPermissionsContext.userPrivileges.hasChartWritePrivilege) &&
                    clinicalListItems)),
        isExportOpen && (React.createElement(ExportModalCard, { headerTitle: exportHeaderTitle, isOpen: isExportOpen, onClose: handleExportClose, exportData: exportData })),
        isPatientEducationOpen && (React.createElement(PatientEducationModal, { isOpen: isPatientEducationOpen, onClose: handlePatientEducationClose, ptEdUrl: PATIENT_EDUCATION_URL + "patientId=" + patientId })),
        isSOCModalOpen && (React.createElement(ImportSummaryOfCare, { patientId: patientId, isModalOpen: isSOCModalOpen, closeSOCModal: closeSOCModal }))));
};
export default MoreMenu;
var templateObject_1;
